"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { ReactNode, useCallback } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import BottomNavigation from "../navigation/BottomNavigation";
import { useViewContext } from "../navigation/ViewContext";
import BrainMobileWaves from "../brain/mobile/BrainMobileWaves";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import HeaderPlaceholder from "../header/HeaderPlaceholder";
import { useHeaderContext } from "@/contexts/HeaderContext";
import { useDeepLinkNavigation } from "@/hooks/useDeepLinkNavigation";
import BrainMobileMessages from "../brain/mobile/BrainMobileMessages";
import { useSelector } from "react-redux";
import { selectEditingDropId } from "@/store/editSlice";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
const TouchDeviceHeader = dynamic(() => import("../header/AppHeader"), {
  ssr: false,
  loading: () => <HeaderPlaceholder />
});
interface Props {
  readonly children: ReactNode;
}
export default function AppLayout(t0) {
  const $ = _c(29);
  const {
    children
  } = t0;
  useDeepLinkNavigation();
  const {
    registerRef
  } = useLayout();
  const {
    setHeaderRef
  } = useHeaderContext();
  const {
    activeView,
    homeActiveTab
  } = useViewContext();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("drop");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSingleDropOpen = t1 !== null;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams?.get("wave");
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const waveParam = t2;
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams?.get("view");
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const viewParam = t3;
  const hasWaveParam = Boolean(waveParam);
  const isViewingWavesOrMessages = viewParam === "waves" || viewParam === "messages";
  const isStreamRoute = pathname === "/waves" || pathname === "/messages" || pathname === "/notifications" || pathname === "/" && (hasWaveParam || isViewingWavesOrMessages);
  const isHomeFeedView = pathname === "/" && homeActiveTab === "feed";
  const editingDropId = useSelector(selectEditingDropId);
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible,
    isAndroid
  } = useAndroidKeyboard();
  const isEditingOnMobile = isApp && editingDropId !== null;
  const shouldHideBottomNav = isAndroid && isKeyboardVisible;
  let t4;
  if ($[6] !== registerRef || $[7] !== setHeaderRef) {
    t4 = node => {
      registerRef("header", node);
      setHeaderRef(node);
    };
    $[6] = registerRef;
    $[7] = setHeaderRef;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const headerWrapperRef = t4;
  const safeAreaClass = shouldHideBottomNav ? "" : "tw-pb-[env(safe-area-inset-bottom,0px)]";
  const t5 = `${safeAreaClass} ${isHomeFeedView ? "tw-overflow-hidden" : "tw-overflow-auto"}`;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TouchDeviceHeader />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== headerWrapperRef) {
    t7 = <div ref={headerWrapperRef}>{t6}</div>;
    $[10] = headerWrapperRef;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeView || $[13] !== children) {
    t8 = activeView === "messages" ? <BrainMobileMessages /> : activeView === "waves" ? <BrainMobileWaves /> : <main>{children}</main>;
    $[12] = activeView;
    $[13] = children;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isHomeFeedView || $[16] !== isSingleDropOpen || $[17] !== isStreamRoute) {
    t9 = !isSingleDropOpen && !isStreamRoute && !isHomeFeedView && <div className="tw-h-16 tw-w-full" />;
    $[15] = isHomeFeedView;
    $[16] = isSingleDropOpen;
    $[17] = isStreamRoute;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isEditingOnMobile || $[20] !== isSingleDropOpen || $[21] !== shouldHideBottomNav) {
    t10 = !isSingleDropOpen && !isEditingOnMobile && <BottomNavigation hidden={shouldHideBottomNav} />;
    $[19] = isEditingOnMobile;
    $[20] = isSingleDropOpen;
    $[21] = shouldHideBottomNav;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className={t5}>{t7}{t8}{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}